import { render } from "./expiry-banner.vue?vue&type=template&id=95c8aa9e"
import script from "./expiry-banner.vue?vue&type=script&lang=js"
export * from "./expiry-banner.vue?vue&type=script&lang=js"

import exportComponent from "/builds/commerce/central/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__